"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOSE_TOAST_NOTIFICATION = exports.SHOW_TOAST_NOTIFICATION = void 0;
exports.SHOW_TOAST_NOTIFICATION = '@toastNotification/SHOW_TOAST_NOTIFICATION';
exports.CLOSE_TOAST_NOTIFICATION = '@toastNotification/CLOSE_TOAST_NOTIFICATION';